<ion-footer class="head">
  <div class="container">
    <ion-row class="row">
      <ion-col class="col-lg-2">
        <ul>
          <li>{{'0%commissionmoreprofit' | language:' 0% Commission More Profit '}}</li>
          <li>{{'lowcostsubscription' | language:' Low Cost Subscription '}}</li>
          <li>{{'setuponlinein5minutes' | language:' Setup Online in 5 Minutes '}}</li>
          <li>{{'unlimitedtransactions&orders' | language:' Unlimited Transactions & Orders '}}</li>
          <li>{{'multilingual&24/7availability' | language:' Multilingual & 24/7 Availability '}}</li>
          <li>{{'yourbusinessyourcontrol' | language:' Your Business Your Control '}}</li>
        </ul>
      </ion-col>
      <ion-col class="col-lg-2">
        <ul>
          <li>{{'sellfruitsonline' | language:' Sell Fruits Online '}}</li>
          <li>{{'sellvegetablesonline' | language:' Sell Vegetables Online '}}</li>
          <li>{{'sellgroceryonline' | language:' Sell Grocery Online '}}</li>
          <li>{{'sellfishandmeatonline' | language:' Sell Fish and Meat Online '}}</li>
          <li>{{'sellbakeryandsweetsonline' | language:' Sell Bakery and Sweets Online '}}</li>
          <li>{{'selldairyandsnacksonline' | language:' Sell Dairy and Snacks Online '}}</li>
        </ul>
      </ion-col>
      <ion-col class="col-lg-2">
        <ul>
          <li>{{'sellrestaurantfoodonline' | language:' Sell Restaurant Food Online '}}</li>
          <li>{{'sellhomefoodsonline' | language:' Sell Home Foods Online '}}</li>
          <li>{{'sellpetfoodsonline' | language:' Sell pet Foods Online '}}</li>
          <li>{{'sellayurvedicproductsonline' | language:' Sell Ayurvedic Products Online '}}</li>
          <li>{{'sellflowerandpoojaitemsonline' | language:' Sell Flower and Pooja Items Online'}}</li>
          <li>{{'sellpaanonline' | language:' Sell Paan Online '}}</li>
        </ul>
      </ion-col>
      <ion-col class="col-lg-2">
        <ul>
          <li>{{'buyfruitsonline' | language:' Buy Fruits Online '}}</li>
          <li>{{'buyvegetablesonline' | language:' Buy Vegetables Online '}}</li>
          <li>{{'buygroceryonline' | language:' Buy Grocery Online '}}</li>
          <li>{{'buyfishandmeatonline' | language:' Buy Fish and Meat Online '}}</li>
          <li>{{'buybakeryandsweetsonline' | language:' Buy Bakery and Sweets Online '}}</li>
          <li>{{'buydairyandsnacksonline' | language:' Buy Dairy and Snacks Online '}}</li>
        </ul>
      </ion-col>
      <ion-col class="col-lg-2">
        <ul>
          <li>{{'buyrestaurantfoodonline' | language:' Buy Restaurant Food Online '}}</li>
          <li>{{'buyhomefoodsonline' | language:' Buy Home Foods Online '}}</li>
          <li>{{'buypetfoodsonline' | language:' Buy pet Foods Online '}}</li>
          <li>{{'buyayurvedicproductsonline' | language:' Buy Ayurvedic Products Online '}}</li>
          <li>{{'buyflowerandpoojaitemsonline' | language:' Buy Flower and Pooja Items Online '}}</li>
          <li>{{'buypaanonline' | language:' Buy Paan Online '}}</li>
        </ul>
      </ion-col>
    </ion-row>
    <div class="icon">
      <a href="https://www.facebook.com/SarvM.AI.ForEveryone" target="_blank">
        <ion-icon name="logo-facebook" color="dark"></ion-icon>
      </a>
      <a href="https://www.linkedin.com/company/sarvm-ai-tech/" target="_blank">
        <ion-icon name="logo-linkedin" color="dark"></ion-icon>
      </a>
      <a href="https://www.instagram.com/sarvm.ai/" target="_blank">
        <ion-icon name="logo-instagram" color="dark"></ion-icon>
      </a>
      <a href="https://x.com/i/flow/login?redirect_after_login=%2Faisarvm" target="_blank">
        <ion-icon name="logo-twitter" color="dark"></ion-icon>
      </a>
      <a href="https://www.youtube.com/channel/UC0n8aaHQTVtL8cxwDzQTQRw" target="_blank">
        <ion-icon name="logo-youtube" color="dark"></ion-icon>
      </a>
    </div>
    <div>
      <div class="border"></div>
      <div class="bottom">
        <p class="copyright">Copyright &copy; 2025 SarvM.AI</p>
        <p class="powered">Powered by SarvM.AI</p>
      </div>
    </div>
  </div>
</ion-footer>